import { render, staticRenderFns } from "./specialDetail.vue?vue&type=template&id=2ab8676a&scoped=true&"
import script from "./specialDetail.vue?vue&type=script&lang=js&"
export * from "./specialDetail.vue?vue&type=script&lang=js&"
import style0 from "./specialDetail.vue?vue&type=style&index=0&id=2ab8676a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab8676a",
  null
  
)

export default component.exports